import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as h } from "react";
const v = ({
  title: c,
  titleId: l,
  ...o
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...o,
    children: [
      c ? /* @__PURE__ */ e.jsx("title", { id: l, children: c }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M609.696 511.042H275.573v154.325c0 50.389 1.237 83.349 3.776 98.901 2.453 15.595 8.853 27.157 19.093 34.688 10.24 7.552 29.611 11.328 58.304 11.328h16.469v21.717H85.343v-21.717h16.533c27.328 0 46.336-3.477 56.853-10.368 10.517-6.976 17.301-17.728 20.267-32.32 2.965-14.677 4.48-48.725 4.48-102.229V351.511c0-50.965-1.515-83.861-4.48-98.624-2.965-14.784-9.301-25.024-18.88-30.677-9.579-5.675-30.571-8.512-63.019-8.512H85.342v-21.696h287.872v21.696h-11.84c-31.083 0-51.541 2.624-61.269 7.787-9.813 5.227-16.32 14.891-19.605 29.035-3.349 14.165-4.928 47.808-4.928 100.992v126.955h334.123V351.512c0-50.965-1.429-83.861-4.267-98.624-2.837-14.784-9.088-25.024-18.667-30.677-9.579-5.675-30.571-8.512-63.019-8.512h-17.003v-21.696H797.96v21.696h-9.429c-31.445 0-52.053 2.624-61.781 7.787-9.813 5.227-16.341 14.891-19.605 29.035-3.349 14.165-4.928 47.808-4.928 100.992v313.856c0 50.389 1.152 83.349 3.477 98.901 2.389 15.595 8.704 27.157 19.157 34.688 10.325 7.552 29.845 11.328 58.539 11.328h14.571v21.717H506.74v-21.717h22.229c27.072 0 45.888-3.477 56.405-10.368 10.539-6.976 17.216-17.728 20.053-32.32 2.837-14.677 4.267-48.725 4.267-102.229V511.044zm279.71-139.541 37.952-36.181c8.533-8.277 14.528-15.083 14.528-27.349 0-13.184-10.517-22.4-25.579-22.4H814.526c-12.096 0-21.952 9.856-21.952 21.973 0 11.797 10.048 21.76 21.952 21.76h59.093l-37.163 37.333c-7.403 7.659-10.411 13.525-10.411 20.267 0 12.117 9.856 21.973 21.995 21.973h7.04c14.485 0 38.827 3.157 38.827 24.32v.64c0 14.123-10.816 23.253-27.541 23.253-15.061 0-27.2-4.651-39.381-15.083-3.413-2.816-8.32-6.037-16.085-6.037-13.184 0-24.299 11.051-24.299 24.107 0 7.701 4.352 14.635 8.619 18.027 18.539 16.213 42.347 24.427 70.72 24.427 46.315 0 77.44-28.288 77.44-70.4v-.64c0-31.979-18.624-52.629-53.973-59.989z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = h(v);
export {
  n as default
};
